import React from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import type { ImportAdvarsel, ImportFeilRad } from "@/services/api/types";

const feilTekst = (f: ImportFeilRad | ImportAdvarsel): string => {
  if (f.radnr === undefined) return f.melding;
  return f.kolonne
    ? `Rad ${f.radnr} (${f.kolonne}): ${f.melding}`
    : `Rad ${f.radnr}: ${f.melding}`;
};

interface Props {
  feil: (ImportFeilRad | ImportAdvarsel)[];
  /** `advarsel` vises dempet og stopper aldri importen. */
  variant?: "feil" | "advarsel";
}

/** Feil eller advarsler fra server eller validering. Alltid vist som tekst. */
const ImportFeilListe: React.FC<Props> = ({ feil, variant = "feil" }) =>
  feil.length === 0 ? null : (
    <Alert
      variant={variant === "feil" ? "destructive" : "default"}
      role={variant === "feil" ? "alert" : "status"}
      className={
        variant === "advarsel"
          ? "border-status-waiting/50 bg-status-waiting/10"
          : undefined
      }
    >
      <AlertDescription>
        <ul className="list-disc space-y-1 pl-5 max-h-48 overflow-y-auto">
          {feil.map((f, i) => (
            <li key={i}>{feilTekst(f)}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );

export default ImportFeilListe;
